<template>
    <section>
        <TextInput 
            :label="name.label"
            :placeholder="name.label"
            :importedData="name.value"
            @update:value="name.value = $event"
            class="mbottom-m"
            :valid="name.valid"
            :validationMessage="name.validationMessage"
        />

        <TextInput 
            :label="city.label"
            :placeholder="city.label"
            :importedData="city.value"
            @update:value="city.value = $event"
            class="mbottom-m"
            :valid="city.valid"
            :validationMessage="city.validationMessage"
        />

        <TextInput 
            :label="address.label"
            :placeholder="address.label"
            :importedData="address.value"
            @update:value="address.value = $event"
            class="mbottom-m"
            :valid="address.valid"
            :validationMessage="address.validationMessage"
        />

        <TextInput 
            :label="email.label"
            :placeholder="email.label"
            :importedData="email.value"
            @update:value="email.value = $event"
            class="mbottom-m"
            :valid="email.valid"
            :validationMessage="email.validationMessage"
        />

        <TextInput 
            :label="phone.label"
            :placeholder="phone.label"
            :importedData="phone.value"
            @update:value="phone.value = $event"
            class="mbottom-m"
            :valid="phone.valid"
            :validationMessage="phone.validationMessage"
        />
        
        <textarea 
            rows="7" 
            style="width: 100%; padding: 10px; box-sizing: border-box; font-size: .8rem"
            class="mbottom-l"
            v-model="about.value"
            placeholder="Описание"
        ></textarea>

        <GZ-BaseButton
            :value="$route.params.id ? 'изменить данные' : 'добавить юр лицо'"
            class="gz-button gz-button_default" 
            icon="icon-flag"
            :loading="loading"
            @click="$route.params.id ? editServiceEntity() : addServiceEntity()"
        />
    </section>
</template>

<script>
import TextInput from '@/components/ui/jg_forms/text-input/TextInput'

export default {
    name: 'AddStaffForm',

    components: {
        TextInput
    },
    data() {
        return {
            name: {
                label: 'Название',
                value: '',
                valid: true,
                validationMessage: ''
            },
            city: {
                label: 'Населенный пункт',
                value: '',
                valid: true,
                validationMessage: ''
            },
            address: {
                label: 'Адрес',
                value: '',
                valid: true,
                validationMessage: ''
            },
            email: {
                label: 'Email',
                value: '',
                valid: true,
                validationMessage: ''
            },
            phone: {
                label: 'Телефон',
                value: '',
                valid: true,
                validationMessage: ''
            },
            about: {
                label: 'Описание',
                value: '',
                valid: true,
                validationMessage: ''
            },

            loading: false
        }
    },
    mounted() {
        if (this.$route.params.id) {
            this.$store.dispatch('serviceEntityGet', this.$route.params.id)
                .then(() => {
                    const data = this.$store.getters['serviceEntity'].attributes

                    this.name.value = data.name
                    this.city.value = data.city
                    this.address.value = data.address
                    this.email.value = data.email
                    this.phone.value = data.phone
                    this.about.value = data.about
                })
        }
    },
    methods: {
        validation() {
            const message = this.$store.getters['validationMessages']

            let errors = 0
            //Empty fields

            //** Name */
            //Не пустое
            //Sintax
            if (!this.isEmpty(this.name.value)) {
                this.formValidationUtil(this.name, false, message.isEmtpy)
                errors++
            } else {
                this.formValidationUtil(this.name, true, '')
            }

            //** Email */
            //Не пустое
            if (this.email.value) {
                //Sintax
                if (!this.emailValidation(this.email.value)) {
                    this.formValidationUtil(this.email, false, message.uncorrectEmail)
                    errors++
                } else {
                    this.formValidationUtil(this.email, true, '')
                }
            }            

            //Notification
            return this.validationNotification(errors)
        },
        setAttributes() {
            const attributes = {
                uid: this.$store.getters['authUserId'],
                name: this.name.value,
                address: this.address.value,
                city: this.city.value,
                email: this.email.value,
                phone: this.phone.value,
                about: this.about.value
            }

            return attributes
        },
        addServiceEntity() {
            if (this.validation()) {
                this.$axios({
                    method: 'POST',
                    url: 'svcentity',
                    data: {
                        data: {
                            type: 'svcentity',
                            attributes: this.setAttributes()
                        }
                    }
                })
                .then(response => {
                    this.$store.dispatch('modalNotificationMessageOpen', ['Объект добавлен'])
                    this.$store.dispatch('modalClose')
                })
                .catch(err => {
                    console.error('Ошибка добавления данных о юр лице: ', err.response)
                })
            }
        },
        editServiceEntity() {
            this.$axios({
                method: 'PATCH',
                url: 'svcentity/' + this.$route.params.id,
                data: {
                    data: {
                        type: 'svcentity',
                        attributes: this.setAttributes()
                    }
                }
            }, this.loading = true)
            .then(({data}) => {
                this.$store.dispatch('modalNotificationMessageOpen', ['Информация изменена'])
                this.loading = false                    
            })
            .catch(err => {
                console.error('Ошибка добавления данных в профиль: ', err.response)
                this.loading = false                    
            })
        }
    },
    watch: {
        $route() {
            //Если редактирование
            this.$store.dispatch('serviceEntityGet', this.$route.params.id)
                .then(() => {
                    const data = this.$store.getters['serviceEntity'].attributes

                    this.name.value = data.name
                    this.city.value = data.city
                    this.address.value = data.address
                    this.email.value = data.email
                    this.phone.value = data.phone
                    this.about.value = data.about
                })
        }
    }
}
</script>